import { api } from '@/fsd/shared/api';
import { IAccess } from '../../model/types/IAccess';

export const getAccess = async (): Promise<IAccess[] | undefined> => {
  try {
    const data = await api.get<{ data: IAccess[] }>('/api/v1/access/');

    return data?.data;
  } catch (e) {
    console.error('Ошибка при получении доступов:', e);
    return;
  }
};
